export default __webpack_public_path__ + "static/media/writing_helper.ef90a104.png";